const loader_header = [
			{ title: "Tires, wheels, stem caps, lug nuts", description: "Inflation, leaks, damage, wear" },
			{ title: "Bucket cutting edge, moldboard", description: "Excessive wear, damage" },
			{ title: "Bucket lift and tile cylinders, all lines and hoses", description: "Excessive wear, damage, leaks" },
			{ title: "Loader frame, arms", description: "Excessive wear, damage" },
			{ title: "Underneath machine", description: "Leaks, damage" },
			{ title: "Transmission, transfer case", description: "Leaks" },
			{ title: "Steps and handolds", description: "Condition, cleanliness" },
			{ title: "Fuel tank", description: "Fuel level, damage, leaks" },
			{ title: "Differential and final drive oil", description: "Fluid level" },
			{ title: "Air tank (if equipped)", description: "Drain moisture" },
			{ title: "Axles - final drives, differentials, brakes, duo-cone seals", description: "Leaks, damage, wear" },
			{ title: "Hydraulic tank", description: "Fluid level, damage, leaks" },
			{ title: "Transmission oil", description: "Fluid level" },
			{ title: "Lights, front and rear", description: "Function, damaged lens, housing, or wiring" },
			{ title: "Battery compartment", description: "Cleanliness, connections, loose nuts and bolts" },
			{ title: "Diesel exhaust fluid (DEF) tank (if equipped)", description: "Fluid level, check for debris buildup" },
			{ title: "Overall machine", description: "Loose or missing nuts & bolts, loose guards, cleanliness" },
			{ title: "Engine oil", description: "Fluid level" },
			{ title: "Engine coolant", description: "Fluid level" },
			{ title: "Radiator", description: "Fin blockage, leaks" },
			{ title: "All hoses and lines", description: "Cracks, wear spots, leaks" },
			{ title: "Fuel filters / water seperator", description: "Leaks / drain water (if equipped)" },
			{ title: "All belts", description: "Tension, wear, cracks" },
			{ title: "Air filter", description: "Restriction indicator" },
			{ title: "Overall engine compartment", description: "Trash or dirt buildup, leaks" },
			{ title: "Handholds", description: "Condition, cleanliness" },
			{ title: "ROPS", description: "Damage, loose mounting bolts" },
			{ title: "Fire extinguisher/system", description: "Charge, damage" },
			{ title: "Windshield, windows", description: "Broken glass, cleanliness" },
			{ title: "Windshield wipers / washers", description: "Wear, damage/fluid level" },
			{ title: "Doors", description: "Open properly, broken glass" },
			{ title: "Seat", description: "Adjustment-height/weight, able to reach pedals" },
			{ title: "Seat belt and mounting", description: "Damage, wear, adjustment, age of seatbelt, installation date" },
			{ title: "Horn, backup alarm, lights", description: "Proper function" },
			{ title: "Mirrors", description: "Damage, adjust for best visibility" },
			{ title: "Cab air filter", description: "Dirt, dust" },
			{ title: "Gauges, indicators, switches, controls", description: "Damage, function" },
			{ title: "Overall cab interior", description: "Cleanliness" },
		]

export default loader_header;